<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="10">
        <div class="grid_half">
          <div class="grid_flex text-md-left text-lg-left text-xl-left ma-4 justify-start">
            <div class="pr-2">รายการสินค้า /</div>
            <div style="color: #86bc3a;">{{ get_month }} {{ get_year }}</div>
          </div>
          <div class="grid_flex ma-4 justify-end">
            <div class="mr-2">ยอดค้างชำระทั้งหมด</div>
            <div class="green--text mr-1">{{ format_number(total) }} <span class="black--text">฿</span></div>
          </div>
        </div>
        <div class="pa-4">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="PuHeaders" :items="pu_lists" key="index" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail" class="grid_btn">
              <tr>
                <td>{{ dataDetail.index + 1 }}</td>
                <td>{{ dataDetail.item.supplier_name }}</td>
                <td>{{ format_number(dataDetail.item.total) }}</td>
                <td><v-btn x-large @click="get_detail(dataDetail.item.supplier_id)" class="ma-2 pa-6 grad-success-bg white--text" style="font-size: 18px"><v-icon>mdi-magnify</v-icon> ดูรายละเอียด</v-btn></td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-dialog v-model="pu_details" max-width="900">
          <v-card>
            <div v-if="loading_modal === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-form ref="pu_details" @submit.prevent="">
                <v-card-text>
                  <div class="pa-4">
                    รายการใบ PU
                  </div>
                  <div class="pa-4">
                    <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
                    <v-data-table :headers="header" :items="data_list" key="index" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
                      <template v-slot:item="dataDetail" class="grid_btn">
                        <tr>
                          <td>{{ dataDetail.index + 1 }}</td>
                          <td>{{ dataDetail.item.receipt_no }}</td>
                          <td>{{ dataDetail.item.credit_date }}</td>
                          <td>{{ format_number(dataDetail.item.total) }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="grad-danger-bg pa-6 white--text" type="button" @click="pu_details = false">
                    ยกเลิก
                  </v-btn>
                </v-card-actions>
              </v-form>
            </div>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "PuList",
  data() {
    return {
      loading_page: false,
      loading_modal: false,
      pu_details: false,
      search: null,
      total: 0,
      get_month: '',
      get_year: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      PuHeaders: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '100px',
        },
        {
          text: 'ชื่อบริษัท',
          value: 'name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ยอดค้างชำระ',
          value: 'balance',
          fixed: true,
          width: '150px',
        },
        {
          text: 'เมนูจัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
      pu_lists: [],
      header: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '100px',
        },
        {
          text: 'หมายเลข PU',
          value: 'receipt_no',
          fixed: true,
          width: '250px',
        },
        {
          text: 'วันที่ครบกำหนด',
          value: 'credit_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ยอดค้างชำระ',
          value: 'total',
          fixed: true,
          width: '150px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('creditor/showcreditorbymonth', {
        month: this.$route.params.month,
        year: this.$route.params.year,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.pu_lists = res.data.object.pu_lists
          this.total = res.data.object.sum
          this.get_month = res.data.object.month_name
          this.get_year = res.data.object.year
        }
      })
    },
    get_detail(supplier_id) {
      this.data_list = []
      this.pu_details = true
      this.loading_modal = true
      HTTP.post('creditor/showpubysupid', {
        month: this.$route.params.month,
        year: this.$route.params.year,
        supplier_id: supplier_id,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.data_list = res.data.object.pu_lists
        }
      })
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_flex {
  display: flex;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  font-size: 26px;
}
@media only screen and (max-width: 750px) {
  .grid_half {
    display: grid;
    grid-template-columns: 25% 75%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
  }
}
</style>
